// Single fixed grain-texture overlay for the whole page, replacing the
// previous per-section noise layers (8x fewer painted noise layers).
export const GlobalNoiseOverlay = () => <div className="bg-noise-global" aria-hidden="true" />;
